export const orderTypes = {
  1: '充值',
  2: '充电',
  3: '充电赠送',
  4: '合伙人充电分成',
  5: '合伙人贡献收益',
  6: '商家分成',
  7: '月卡分成',
  10: '充电退款 ',
  11: '充值退款',
  13: '赠送',
  20: '发起提现',
  21: '提现',
  22: '提现退回'
}

export const orderStatus = {
  1: '等待开始',
  2: '进行中',
  3: '已完成',
  4: '异常停止',
  5: '人工关闭',
  6: '退单'
}

export const payTypes = {
  1: '钱包支付',
  2: '月卡支付',
  3: '微信支付'
}

export const test = {}
